import script from "./PushEnableModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PushEnableModal.vue?vue&type=script&setup=true&lang=js"

import "./PushEnableModal.vue?vue&type=style&index=0&id=d36c31e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d36c31e6"]])

export default __exports__